import { MessageUltis } from "../../services/helpers/MessageUltis";
import { CONVERSATION_TYPE } from "../constants";
const _ = require('lodash');

export const CONVERSATION_TYPE_ENUM = {
   THREAD_TYPE: {
      ALL: 0,
      MESSAGE: 1,
      COMMENT: 2
   },
   ASSIGN_TYPE: {
      ALL: 0,
      MY: 1,
      NOT_SPECIFIED: 2
   }
}

const FILTER_DEFAULT = {
   message: false,
   comment: false,
   unread: false,
   tag: false,
   phone: false,
   answer: false,
   cart: false,
   user: false,
   post: false,
   remind: false,
   time: {
      active: false,
      startTime: new Date(),
      endTime: new Date()
   },
   assign: CONVERSATION_TYPE_ENUM.ASSIGN_TYPE.ALL
}
const conversationReducer = (state = {
   conversations: [],
   filter: FILTER_DEFAULT,
   order: {
      lineItems: []
   },
   historyOrder: [],
   transporters: []
}, action) => {
   switch (action.type) {
      case CONVERSATION_TYPE.GET_ALL_INBOX:
         return {
            ...state,
            conversations: _.isArray(action.payload.inbox) ? action.payload.inbox.map(m => {
               return {
                  ...m,
                  isLoadMs: true,
                  messages: []
               }
            }) : []
         };
      case CONVERSATION_TYPE.GET_MORE_ALL_INBOX:
         return {
            ...state,
            conversations: [
               ...state.conversations,
               ..._.isArray(action.payload.inbox) ? action.payload.inbox.map(m => {
                  return {
                     ...m,
                     isLoadMs: true,
                     messages: []
                  }
               }) : []
            ]
         };
      case CONVERSATION_TYPE.LOAD_ALL_DATA:
         return state;
      case CONVERSATION_TYPE.GET_INBOX:
         //payload chứa data và threadId;
         return {
            ...state,
            conversations: state.conversations.map((m) => {
               if (m.threadId === action.payload.threadId) {
                  m.isLoadMs = false;
                  m.messages = _.isArray(action.payload.data.inbox) ? action.payload.data.inbox : [];
               }
               return m;
            })
         };
      case CONVERSATION_TYPE.GET_MORE_INBOX:
         //payload chứa data và threadId;
         return {
            ...state,
            conversations: state.conversations.map((m) => {
               if (m.threadId === action.payload.threadId) {
                  m.messages = [
                     ...m.messages,
                     ..._.isArray(action.payload.data.inbox) ? action.payload.data.inbox : []
                  ];
               }
               return m;
            })
         };
      case CONVERSATION_TYPE.SEARCH_INBOX:
         return state;
      case CONVERSATION_TYPE.TEMP_MESSAGE:
         //payload chứa data và threadId;
         state.conversations = MessageUltis.addTempMessage(state.conversations, _.isArray(action.payload.data.inbox) ? action.payload.data.inbox : []);
         return {
            ...state,
            conversations: MessageUltis.sortConversation(state.conversations)
         }
      case CONVERSATION_TYPE.SEND_MESSAGE:
         //payload chứa data và threadId;
         state.conversations = MessageUltis.updateTempMessage(state.conversations, _.isArray(action.payload.data.inbox) ? action.payload.data.inbox : [], action.payload.data.tempId);
         return {
            ...state,
            conversations: MessageUltis.sortConversation(state.conversations)
         }
      case CONVERSATION_TYPE.REPLY_COMMENT:
         return state;
      case CONVERSATION_TYPE.EDIT_COMMENT:
         return state;
      case CONVERSATION_TYPE.HIDE_COMMENT:
         return state;
      case CONVERSATION_TYPE.DELETE_COMMENT:
         return state;
      case CONVERSATION_TYPE.SET_STATUS:
         //payload chứa isRead, isImportant và threadId;
         return {
            ...state,
            conversations: state.conversations.map((m) => {
               if (m.threadId === action.payload.threadId) {
                  m.isRead = action.payload.isRead;
                  m.isImportant = action.payload.isImportant;
               }
               return m;
            })
         };
      case CONVERSATION_TYPE.SET_FILTER:
         return {
            ...state,
            filter: action.payload
         }
      case CONVERSATION_TYPE.RESET_FILTER:
         return {
            ...state,
            filter: FILTER_DEFAULT
         }
      case CONVERSATION_TYPE.MESSAGE_SOCKET:
         const { data } = action.payload;
         //data là 1 mảng tin nhắn nên foreach để kiểm tra từng tin nhắn 1
         state.conversations = MessageUltis.addMessageToConversations(state.conversations, data);
         return {
            ...state,
            conversations: MessageUltis.sortConversation(state.conversations)
         }
      case CONVERSATION_TYPE.CREATE_DRAFT:
         return {
            ...state,
            order: action.payload
         }
      case CONVERSATION_TYPE.CLEAR_DRAFT:
         return {
            ...state,
            order: {
               lineItems: []
            }
         }
      case CONVERSATION_TYPE.PURCHASE_HISTORY:
         return {
            ...state,
            historyOrder: action.payload
         }
      case CONVERSATION_TYPE.ORDER_CANCEL:
         return {
            ...state,
            historyOrder: state.historyOrder.filter(f => f.id !== action.payload)
         }
      case CONVERSATION_TYPE.GET_LIST_CONNECTED_TRANS_BY_SHOP:
         return {
            ...state,
            transporters: action.payload
         }
      case CONVERSATION_TYPE.GET_SERVICE:
         return {
            ...state,
            transporters: state.transporters.map((transporter) =>{
               if (transporter.id === action.payload.id) {
                  return {
                     ...transporter,
                     services: action.payload.data
                  }
               }
               return transporter;
            })
         }
      default:
         return state;
   }

}

export default conversationReducer;